<style>
</style>
<template>
    <div class="c-pg-tokenization">
        <Request
                ref="request"
                method="POST"
                :requestConfigs="{'Content-Type':'application/json'}"
                :onRequestSuccess="onTokenizationSuccess"
                :onRequestError="onTokenizationError"
                :url="Core.Session.paymentGateway.tokenizationCallUrl">
            <slot slot="body"><slot name="body"></slot></slot>
        </Request>
    </div>
</template>

<script>
    import Request from './Request'
    export default {
        name: 'PGTokenization',
        components: {
            Request,
        },
        props: {
            onTokenizationSuccess: {
                type: Function,
                default: function() {
                    return false
                }
            },
            onTokenizationError: {
                type: Function,
                default: function() {
                    return false
                }
            },
        },
        data: () => {
            return {
                Core: window.Core
            }
        },
        mounted() {
        },
        methods: {
            request(number, holderName, expMonth, expYear, CVD) {
                if (Core.Session.paymentGateway.tokenizationCallUrl !== undefined && Core.Session.paymentGateway.tokenizationCallUrl !== '') {
                    this.$refs.request.clearArgs()
                    this.$refs.request.addArg('number', number)
                    this.$refs.request.addArg('expiry_month', expMonth)
                    this.$refs.request.addArg('expiry_year', expYear)
                    this.$refs.request.addArg('cvd', CVD)
                    this.$refs.request.request()
                } else {
                    this.onTokenizationError()
                }
            },
            requestSuccess(data) {
                if (data.token !== undefined) {
                    this.onTokenizationSuccess(data.token)
                } else {
                    this.onTokenizationError()
                }
            }
        }
    }
</script>
